export const path = "integracao/csv-precos-cursos";
